import React, { useEffect, useRef } from 'react';
import * as PIXI from 'pixi.js-legacy';

import { getPixiComponent } from 'components/FreecodePlayer/pixiComponent';
import { Animations } from 'assets/images';

import { AnimationData } from './animation.data.js';
import { CanvasContainer } from './styles';

const canvasId = 'landingPageCanvas';

export default function LandingAnimation({ width = '100vw', height = '100vh' }) {
  const containerRef = useRef(null);
  const PixiComponentRef = useRef(getPixiComponent());

  const getAnimationTextures = (animationData, spriteSheet) => {
    let frameOrder = animationData.animations.default;
    const base = new PIXI.BaseTexture(spriteSheet);
    const spriteSheetTexture = new PIXI.Texture(base).baseTexture;

    // create an array to store the textures
    const animationTextures = [];

    // Get individual textures from spritesheet
    for (let frameIndex = 0; frameIndex < frameOrder.length; frameIndex++) {
      const spriteData = animationData.frames[frameOrder[frameIndex]];
      if (spriteData.trimmed) {
        animationTextures.push(
          new PIXI.Texture(
            spriteSheetTexture,
            new PIXI.Rectangle(spriteData.frame.x, spriteData.frame.y, spriteData.frame.w, spriteData.frame.h), // frame
            new PIXI.Rectangle(0, 0, spriteData.sourceSize.w, spriteData.sourceSize.h), // original size
            new PIXI.Rectangle(
              spriteData.spriteSourceSize.x,
              spriteData.spriteSourceSize.y,
              spriteData.spriteSourceSize.w,
              spriteData.spriteSourceSize.h
            )
          )
        );
      } else {
        animationTextures.push(
          new PIXI.Texture(
            spriteSheetTexture,
            new PIXI.Rectangle(spriteData.frame.x, spriteData.frame.y, spriteData.frame.w, spriteData.frame.h)
          )
        );
      }
    }
    return animationTextures;
  };

  useEffect(() => {
    PixiComponentRef.current.initialize({
      resizeTo: containerRef.current,
      antialias: true,
      view: document.getElementById(canvasId),
      backgroundAlpha: 0,
    });

    const app = PixiComponentRef.current.app;
    app.renderer.events.autoPreventDefault = false;
    app.renderer.view.style.touchAction = 'auto';

    //   create an explosion AnimatedSprite
    const explosion = new PIXI.AnimatedSprite(getAnimationTextures(AnimationData, Animations.headerAnimation));
    explosion.anchor.set(0.5);
    explosion.animationSpeed = 0.3;
    explosion.onLoop = () => explosion.stop();

    if (app.screen.width > 500) {
      explosion.scale.set(1.2);
      explosion.x = app.screen.width / 2;
      explosion.y = 500;
    } else {
      explosion.y = 400;
    }
    explosion.play();

    // draw a rectangle to animate on hover
    const rectangle = new PIXI.Graphics();
    rectangle.beginFill(0xffff00);
    rectangle.alpha = 0;
    rectangle.eventMode = 'static';
    rectangle.onpointerenter = () => explosion.play();
    rectangle.drawRect(explosion.x, 0, explosion.width / 2.4, explosion.height * 0.7);

    app.stage.addChild(explosion);
    app.stage.addChild(rectangle);
  }, []);

  return (
    <CanvasContainer ref={containerRef} canvasWidth={width} canvasHeight={height}>
      <canvas id={canvasId}></canvas>
    </CanvasContainer>
  );
}
